/** @format */

import EdilentWorkerApi from '@model/api';
import Validator from '@croco/validator';
import di from "dependeny-injection";

/**
 *
 * @package     edilent-worker
 */
class InvoiceProviderApi extends EdilentWorkerApi {
    /**
     * コンストラクタ
     *
     * @access public
     * @return void
     */
    constructor() {
        super('info');
        this.isRegistered = false;
        this._clear();
        this._registerEvent();
    }

    /**
     * バリデーションの取得
     *
     * @access public
     * @return void
     */
    getValidation(name) {
        let validation = new Map([
            ['invoice_provider_number_body', {required: false, validate: false}],
        ]);
        if (validation.has(name)) {
            return validation.get(name);
        }

        return {required: false, validate: false};
    }

    /**
     * 変数の初期化
     *
     * @access private
     * @return void
     */
    _clear() {
        this.item = new Validator({
            invoice_provider_number_body: '',
            invoice_provider_state: 'no',
        });
        this.invoice_provider_number_prefix = 'T'
    }

    /**
     * イベントの登録
     *
     * @access private
     * @return void
     */
    _registerEvent() {
        this.on('fetch', () => {
            this._fetch();
        });
        this.on('save', () => {
            this._save();
        });
    }

    hasFields() {
        let keys = this.item._keys;
        let array = [];
        for (let idx in keys) {
            if (this.item[keys[idx]]) {

                array.push(this.item[keys[idx]]);
            }
        }
        if (0 === array.length) {
            this.fieldsAlert = true;
        } else {
            this.fieldsAlert = false;
        }
        return this.fieldsAlert;
    }

    /**
     * 指定した制作実績の取得
     *
     * @access private
     * @return void
     */
    async _fetch() {
        this._clear();

        let item = await this.request('basicInformation', 'fetch');
        this.isRegistered = !!item.family_name;
        for (const key in item) {
            /**
             *             invoice_provider_number_body: '',
             *             invoice_provider_state: 'unknown',
             */
            const value = ((key === "invoice_provider_state") && (item[key] === "unknown")) ? "no" : item[key];

            if (key === "invoice_provider_number_body") {
                //number_bodyはstateがyes以外の場合は採用しない。number_bodyがあるのはyes（発行事業者）だけのため
                const number_body = (item["invoice_provider_state"] !== "yes") ? "" : value;
                this.item.set(key, number_body, {required: false, validate: false});
            } else {
                this.item.set(key, value, {required: false, validate: false});
            }
        }
        this.hasFields();
        this.trigger('update');
    }

    /**
     * 基本情報の登録/更新
     *
     * @access private
     * @return void
     */
    async _save() {
        this.enable = this.item.validate();
        if (!this.enable) {
            this.trigger('update');
            return;
        }
        if (this.hasFields()) {
            this.trigger('update');
            return;
        }
        let data = new FormData();
        for (const key in this.item) {
            if (this.item.hasOwnProperty(key) && this.item[key]) {
                data.set(key, this.item[key])
            }
        }

        data.set('invoice_provider_number_prefix', this.invoice_provider_number_prefix);
        data.set('application_type', "invoice_provider_only");

        try {
            await this.request('invoiceProvider', 'save', data);
            di.toast.push(`登録・変更申請をしました`, "success");
            if (!this.isRegistered) {
                this.isRegistered = true;
                window.analytics.event("unlock_achievement", {
                    achievement_id: "basic_info_first_application",
                });
            }
        } catch (e) {
            di.toast.push(e, 'negative');
        }
    }
}

const invoiceProviderApi = new InvoiceProviderApi();

export default invoiceProviderApi;
